<template>
    <div v-if="!loading">
        <AppPushNotification ref="notification" :title="notificationModel.title" :text="notificationModel.text"
            :color="notificationModel.color" />
        <div v-if="cartLists.length > 0">
            <div class="mb-2 mt-2">
                <div style="overflow-x: hidden;" class="p-0">
                    <div class="d-flex justify-content-between mb-3 p-2" style="gap: 5px;">
                        <CButton @click="setOrderType('pickup')" style="display: flex;justify-content: center;"
                            :class="{ 'type-button-active': orderType == 'pickup', 'type-button': orderType !== 'pickup' }">
                            <div style="padding-top: 1px;" class="pr-2"><i class="fi fi-rr-shopping-bag"></i></div>
                            {{ $t('pickupType') }}
                        </CButton>
                        <CButton @click="setOrderType('dine-in')" style="display: flex;justify-content: center;"
                            :class="{ 'type-button-active': orderType == 'dine-in', 'type-button': orderType !== 'dine-in' }">
                            <div style="padding-top: 1px;" class="pr-2"><i class="fi fi-rr-utensils"></i></div>
                            {{ $t('dine-in') }}
                        </CButton>
                    </div>
                    <div v-if="orderType == 'delivery'" class="row detail-container mt-3 pl-3 pr-3">
                        <div class="col-2 "><i class="fi fi-rs-marker h4"></i></div>
                        <div class="col-10 text-left p-0 pr-3">
                            <div class="row ">
                                <div class="col-8 h5">{{ $t('deliveryAddress') }}</div>
                                <div @click="$router.push('/delivery/user/addresses')"
                                    style="color:var(--bg-color-theme)" class="col-4 text-right ">
                                    <span v-if="deliveryAddress.name">{{ $t('change')
                                        }}</span>
                                    <span v-else>{{ $t('add')
                                        }}</span>
                                </div>
                            </div>
                            <div v-if="deliveryAddress.address" class="text-description">
                                <span> {{ deliveryAddress.address }}</span><br>
                                <span class="limited-text-one">{{ deliveryAddress.location }}</span>
                                <span class="limited-text-one">{{ deliveryAddress.name }} | {{ deliveryAddress.phone
                                    }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="orderType == 'pickup' || orderType == 'dine-in'" class="row detail-container  pl-3 pr-3">
                        <div class="col-2 "><i class="fi fi-rs-marker h4"></i></div>
                        <div class="col-10 text-left p-0 pr-3">
                            <div v-if="shop.address1" class="row">
                                <div class="col-8">
                                    <div class="text-description">
                                        <div class="h5 text-dark ">{{ $t('shopLocation') }}</div>
                                        <span> {{ shop.address1 }}</span><br>
                                        <span> {{ shop.address2 }}</span>
                                    </div>
                                </div>
                                <div class="col-4 text-center">
                                    <img @click="openGoogleMap()" src="/img/map.webp" width="85%"
                                        style="border-radius: 10px;">
                                </div>
                            </div>
                            <div v-else class="row">
                                <div class="text-description col-12">
                                    <div class="h5 text-dark ">{{ $t('shopLocation') }}</div>
                                    <span @click="openGoogleMap()" style="text-decoration: underline;"> {{
                                        $t('openInGoogleMap') }}</span><br>
                                </div>
                            </div>
                            <!-- <hr> -->
                        </div>
                    </div>

                    <div class="section-cut"></div>
                    <div class="row pl-3 pr-3 p-2">
                        <div class="pl-3 h5">{{ $t('selectedItemList') }}</div>
                        <AppCartLists @item-changed="getCartList" class="detail-container"></AppCartLists>
                    </div>
                    <div class="section-cut"></div>
                    <div class="row detail-container mt-4">
                        <!-- <div class="col-2 "><i class="fi fi-rs-ticket-alt h4"></i></div>
                    <div class="col-10 text-left p-0 pr-3">
                        <div class="row">
                            <div class="col-4 h5">บัตรกำนัล</div>
                            <div class="col-8 text-right"><span style="color: var(--bg-color-theme);">เลือกบัตรกำนัล
                                    ></span></div>
                        </div>
                        <hr>
                    </div> -->
                    </div>
                    <div class="row detail-container pl-3 pr-3">
                        <div class="col-2 "><i class="fi fi-rr-utensils h4"></i></div>
                        <div class="col-10 text-left p-0 pr-3">
                            <div class="row">
                                <div class="col-8 h5">{{ $t('cutlery') }}</div>
                                <div class="col-4 text-right ">
                                    <CSwitch v-model="cutlery" color="success" :value="cutlery"
                                        :checked.sync="cutlery" />
                                </div>
                            </div>
                            <hr>
                        </div>
                    </div>
                    <div class="row detail-container pl-3 pr-3">
                        <div class="col-2 "> <i class="fi fi-rs-edit h4"></i></div>
                        <div class="col-10 text-left p-0 pr-3">
                            <div data-toggle="modal" data-target="#note-modal" class="row">
                                <template v-if="note == ''">
                                    <div class="col-8 text-description h5">{{ $t('noteToShop') }}</div>
                                    <div class="col-4 text-right text-description">
                                        >
                                    </div>
                                </template>
                                <template v-else>
                                    <span style="width: 90%;" class="limited-text-one text-description pl-4">{{ note
                                        }}</span> <span class="text-description"> ></span>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="section-cut"></div>
                    <div class="row detail-container pl-3 pr-3 pt-2">
                        <div class="col-2 "><i class="fi fi-rr-credit-card h4"></i></div>
                        <div class="col-10 text-left p-0 pr-3">
                            <div class="row">
                                <div class="col-8 h5">{{ $t('PaymentMethod') }}</div>
                                <div data-toggle="collapse" data-target="#collapsePaymentMethod"
                                    style="color:var(--bg-color-theme)" class="col-4 text-right ">
                                    <span>{{
                                        $t('change') }}</span>
                                </div>
                                <div style="width: 100%;" class="collapse" id="collapsePaymentMethod">
                                    <div class="payment-method-box pr-3">
                                        <div v-for="(method, index) in filteredPaymentMethods" :key="index"
                                            class="payment-option">
                                            <label data-toggle="collapse" data-target="#collapsePaymentMethod"
                                                class="payment-label" :for="method.id">
                                                <div class="payment-info">
                                                    <img class="payment-icon" :src="`/img/paymentIcon/${method.icon}`">
                                                    {{ $t(method.name) }}
                                                </div>
                                                <div class="radio-container">
                                                    <input type="radio" :id="method.id" v-model="selectedPayment"
                                                        :value="method.id" />
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="text-description">
                                <span>• {{ $t(getPaymentMethodName()) }}</span>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row detail-container pl-3 pr-3 pb-3" style="margin-bottom: 60px;">

                        <table class="styled-table ">
                            <tbody>
                                <tr>
                                    <td class="text-description ">{{ $t('totalAmountSum') }} ({{ selectedItemCount }} {{$t('item')}})</td>
                                    <td class="text-right">{{ netAmount}} THB </td>
                                </tr>
                                <tr v-if="serviceChargeAmount > 0">
                                    <td class="text-description ">{{ $t('serviceCharge') }} {{ shop.serviceCharge + '%' }}</td>
                                    <td class="text-right">{{ serviceChargeAmount }} THB</td>
                                </tr>
                                <tr v-if="!shop.isVATIncluded">
                                    <td class="text-description ">{{ $t('vat') }} {{ shop.VAT }}%</td>
                                    <td class="text-right">{{ vatAmount }} THB </td>
                                </tr>
                                <!-- <tr v-if="orderType == 'delivery'">
                                    <td class="text-description">{{ $t('deliveryFee') }} (5 {{ $t('km') }})</td>
                                    <td class="text-right">23 THB</td>
                                </tr> -->
                                <tr v-if="cartLists.discount">
                                    <td class="text-description">{{ $t('discount') }}</td>
                                    <td class="text-right">2 THB</td>
                                </tr>
                                
                                <tr style="border: none;" class="h4">
                                    <td class="text-dark">{{ $t('totalAmount') }}</td>
                                    <td style="color: var(--bg-color-theme);" class="text-right">{{ totalCost }} THB
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="section-cut"></div>
                    <div v-if="orderAble" class="p-3 fixed-bottom"
                        style="background-color: white; padding-top:5px;  box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.1);">
                        <CButton :disabled="loading" style="font-size: x-large;border-radius: 50px;"
                            @click="goToPaymentgateway()" block class=" bg-color-theme p-2 mb-2 mt-2">
                            <CSpinner v-if="loading" class="mb-1" component="span" size="sm" aria-hidden="true" />
                            &nbsp;
                            {{ $t('checkOut') }}
                        </CButton>
                    </div>
                </div>
                <div class="modal fade small-modal" id="note-modal">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content p-4">
                            <label class="h4" for="Details">{{ $t('noteToShop') }}</label>
                            <textarea style="aspect-ratio: 1/1;" v-model="note" id="Details"
                                class="form-control-theme mt-2"
                                :placeholder="$i18n.t('inputRequestDetails')"></textarea>
                            <div class=" p-0 d-flex justify-content-between mt-3">
                                <button @click="note = ''" style="width: 48%;border-radius: 40px" type="button"
                                    class="btn h4 btn-secondary p-2" data-dismiss="modal">
                                    {{ $t('cancel') }}
                                </button>
                                <button style="width: 48%;border-radius: 40px" type="button"
                                    class="btn h4 bg-color-theme p-2" data-dismiss="modal">
                                    {{ $t('confirm') }}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="d-flex align-items-center justify-content-center" style="height: 90vh;">
            <div class="text-center p-4">
                <img src="/img/cart_empty.png" class="img-fluid " width="40%" alt="" />
                <h4 class="mt-4 font-weight-bold text-dark">{{ $t('noSelectedProduct') }}</h4>
                <span class="text-description">{{ $t('noSelectedProductDespt') }}</span><br>
            </div>
        </div>
    </div>
    <div v-else>
        <div class="c-app" style="background-color: #ffffff">
            <div class="c-wrapper">
                <div class="c-body">
                    <div class="lds-ripple">
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import util from '@/util/util'
import '@/util/menu.css'
import '@/util/tabs.css'
import AppCartLists from '@/components/AppCartLists'
import '@/util/delivery.css'
import { CButton } from '@coreui/vue'
import AppPushNotification from '@/components/AppPushNotification.vue'
import pos from '@/services/pos'
import poscrm from '@/services/poscrm'
import moment from 'moment'
import order from '@/util/order'

export default {
    components: {
        AppCartLists,
        AppPushNotification
    },
    data() {
        return {
            deliveryAddress: {},
            paymentMethod: 'qr',
            showModal: false,
            orderType: 'delivery',
            notificationModel: {
                color: '',
                title: '',
                text: '',
            },
            cartTotal: 0,
            totalCost: 0.0,
            netAmount: 0.0,
            vatAmount: 0.0,
            serviceChargeAmount : 0.0,
            selectedItemCount: 0,
            selectedProducts: [],
            note: '',
            cutlery: false,
            cartLists: [],
            loading: true,
            orderAble: false,
            selectedPayment: 'qr',
            orderShopSetting: {}
        }
    },
    mounted() {
        window.addEventListener('scroll', this.onScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll)
    },
    computed: {
        ...mapGetters(['shopLineOA']),
        uid() {
            return `${localStorage.getItem('uid')}`
        },
        shopObjectId() {
            return `${localStorage.getItem('shopObjectId')}`
        },
        shop() {
            return this.shopLineOA.find(
                (detail) => detail.objectId === this.shopObjectId
            )
        },
        shopName() {
            if (this.shop) {
                return this.shop.shopName
            } else {
                return ''
            }
        },
        selfPaymentGateway() {
            // OrderShopSetting → prioritize this; default "KBANK"
            const gw = (this.orderShopSetting?.selfPaymentGateway || '').toUpperCase();
            return ['KBANK', 'GHL', 'KBANK_GATEWAY'].includes(gw) ? gw : 'KBANK';
        },
        filteredPaymentMethods() {
            const ghlConfig = this.shop?.GHLMethodEnabled || {};
            const ghlEnabled = ghlConfig.enabled === true;
            const kbankEnabled = this.shop?.enabledKPaymentGateway === true;
            const gateway = this.selfPaymentGateway; // ← prioritize orderShopSetting


            const kbankGatewayMethods = [
                {
                    id: 'qr',
                    name: 'QRCode',
                    icon: 'qrIcon.webp',
                    iconHeader: 'thaiqr_banner.webp',
                    bgColor: '#113566',
                    type: 'qr',
                },
                { id: 'credit', name: 'creditCard', icon: 'masterCardIcon.webp', iconHeader: 'credit_.webp', bgColor: '#f5f5f5', type: 'credit' },
            ];

            const kbankMethods = [
                {
                    id: 'qr',
                    name: 'QRCode',
                    icon: 'qrIcon.webp',
                    iconHeader: 'thaiqr_banner.webp',
                    bgColor: '#113566',
                    type: 'qr',
                },
                { id: 'credit', name: 'creditCard', icon: 'masterCardIcon.webp', iconHeader: 'credit_.webp', bgColor: '#f5f5f5', type: 'creditcard' },
            ];


            const ghlMethods = Array.isArray(ghlConfig.methods)
                ? this.paymentMethods.filter((m) => ghlConfig.methods.includes(m.type))
                : [];
            // First, honor the selfPaymentGateway, but also respect each enable flag.
            if (gateway === 'KBANK_GATEWAY') {
                return kbankEnabled ? kbankGatewayMethods : [];
            }
            if (gateway === 'KBANK') {
                return kbankEnabled ? kbankMethods : [];
            }
            if (gateway === 'GHL') {
                // If GHL selected, still ensure GHL is actually enabled
                return ghlEnabled ? ghlMethods : [];
            }


            // Fallback (shouldn't hit because of default), but keep it safe
            if (kbankEnabled) return kbankMethods;
            if (ghlEnabled) return ghlMethods;
            return [];
        },
        paymentMethods() {
            if (this.selfPaymentGateway === 'KBANK' || this.selfPaymentGateway === 'KBANK_GATEWAY') {
                return util.getKbankPaymentMethods();
            }
            return util.getGHLPaymentMethods();
        },

    },
    created() {
        if (!localStorage.getItem('token')) {
            this.$router.push('/delivery/user')
        }

        this.getCartList()
        this.getDeliveryAddress()
        this.orderType = localStorage.getItem('deliveryType') || 'dine-in'
        this.verifyOrderAble()
        this.getOrderShopSetting()
    },
    methods: {
        ...util,
        toNum(value) {
            if (value == null || value === '' || isNaN(value)) return 0
            return Number(value)
        },
        safeDivide(numerator, denominator) {
            const den = this.toNum(denominator)
            if (den === 0) return 0
            return this.toNum(numerator) / den
        },
        showNotification(title, text, color) {
            this.notificationModel = {
                color: color,
                title: title,
                text: text,
            }
            this.$refs.notification.pushNotification();
        },
        openGoogleMap() {
            if (this.shop.location) {
                const url = `https://www.google.com/maps?q=${this.shop.location.lat},${this.shop.location.lng}`;
                window.open(url, '_blank');
            }
        },
        async getCartList() {
            try {

                if (localStorage.getItem('token')) {
                    const uid = localStorage.getItem('uid')
                    const profile = JSON.parse(localStorage.getItem('profile'))
                    const res = await pos({
                        url: `/api/v1.3/${uid}/profile/cart?profileObjectId=${profile.objectId}&shopObjectId=${this.shopObjectId}&limit=100`,
                        method: 'get',
                    })
                    if (res.data.error.code == 0) {
                        this.cartLists = res?.data?.data || []
                        this.selectedProducts = this.cartLists.filter(product => product.isSelected === true) || []
                        this.getSelectedItemCount(this.selectedProducts)

                        this.getCartTotal()
                        this.updateTotalCost()
                    } else if (res.data.error.code == 402) {
                        this.renewToken()
                    } else if (res.data.error.code == 4000) {
                        this.logOut()
                    }
                }
            } catch (error) {
                console.error(error)
            }
        },
        getSelectedItemCount(selectedProducts) {
            let count = 0
            selectedProducts.forEach(item => {
                count += item.quantity
            });
            this.selectedItemCount = count || 0
        },
        async renewToken() {
            try {
                if (localStorage.getItem('refreshToken')) {
                    const refreshToken = localStorage.getItem('refreshToken')

                    let res = {}
                    res = await pos({
                        url: `/auth/v1.0/renewtoken/otp`,
                        method: 'post',
                        data: {
                            "refreshToken": refreshToken
                        }
                    });
                    if (res.data?.error?.code == 0) {
                        localStorage.setItem('token', res.data?.data?.token)
                        window.location.reload()
                    } else {
                        this.logOut()
                    }
                }
            } catch (error) {
                console.error(error);
            }
        },
        logOut() {
            const uid = localStorage.getItem('uid')
            const shopObjectId = localStorage.getItem('shopObjectId')
            sessionStorage.clear()
            localStorage.clear()
            localStorage.setItem('uid', uid)
            localStorage.setItem('shopObjectId', shopObjectId)
            this.$router.push('/delivery/home')
        },
        async goToPaymentgateway() {
            if (this.deliveryAddress.name == undefined && this.typeOfOrder == 4) {
                this.showNotification(this.$i18n.t('noDeliveryAddress'), this.$i18n.t('noDeliveryAddressDespt'), 'warning')
            } else {
                await this.getCartList()
                let selectedProducts = this.cartLists.filter(product => product.isSelected === true)
                let data = {
                    items: selectedProducts,
                    paymentMethod: this.getPaymentMethodKeyName(),
                }
                if (this.orderType == 'delivery') {
                    data.address = this.deliveryAddress
                    data.typeOfOrder = 4
                } else if (this.orderType == 'pickup') {
                    data.typeOfOrder = 3
                } else if (this.orderType == 'dine-in') {
                    data.typeOfOrder = 1
                }
                data.remark = this.note

                if (this.cutlery) {
                    data.remark = this.note ? `${this.note}, ขอช้อนส้อม` : "ขอช้อนส้อม";
                }
                if (selectedProducts.length > 0 && this.orderAble) {
                    this.loading = true
                    const uid = localStorage.getItem('uid')
                    const res = await pos({
                        url: `/api/v1.3/${uid}/profile/order/place?keepItems=false`,
                        method: 'post',
                        data: data,
                    })
                    if (res.data.error.code == 0) {
                        let receipt = {}
                        receipt = res?.data?.data || {}
                        if (selectedProducts.length > 0) {
                            this.$router.push(`/delivery/order-details?objectId=${receipt.objectId}`)
                        }
                        this.loading = false
                    }
                    else if (res.data.error.code == 402) {
                        this.renewToken()
                    } else if (res.data.error.code == 4000) {
                        this.logOut()
                    }
                } else {
                    this.loading = false
                    this.showNotification(this.$i18n.t('pleaseSelectPaymentMethod'), '', 'warning')
                }
            }
        },
        setOrderType(type) {
            if (this.orderType === type) return 

            this.orderType = type
            localStorage.setItem('deliveryType', type)

            this.updateTotalCost()
        },
        getPaymentMethodName() {
            const method = this.paymentMethods.find(m => m.id === this.selectedPayment);
            return method ? method.name : this.$t('pleaseSelectPaymentMethod');
        },
        getPaymentMethodKeyName() {
            const method = this.paymentMethods.find(m => m.id === this.selectedPayment);
            return method ? method.type : 'UNKNOWN METHOD';
        },
        setPaymentMethod(methodId) {
            this.selectedPayment = methodId;
            this.paymentMethod = methodId; // keep the original value in sync
            localStorage.setItem('paymentMethod', methodId);
        },
        async getDeliveryAddress() {
            try {
                if (localStorage.getItem('token')) {
                    const phone = localStorage.getItem('phone')
                    const uid = localStorage.getItem('uid')
                    const objectId = localStorage.getItem('objectId')

                    const res = await pos({
                        url: `/api/v1.3/${uid}/profile/addresses/${objectId}`,
                        method: 'get',
                        data: {
                            phone: phone,
                        }
                    });
                    if (res.data.error.code == 0) {
                        let addresses = res.data.data
                        let defaultAddress = addresses?.find((element) => element.isDefault == true)
                        this.deliveryAddress = defaultAddress || {}
                        this.loading = false
                    } else if (res.data.error.code == 402) {
                        this.renewToken()
                        this.loading = false
                    } else if (res.data.error.code == 4000) {
                        this.logOut()
                    }
                }
            } catch (error) {
                this.showNotification(error, '', 'danger')
                this.loading = false
            }
        },
        trackButtonClick(buttonLabel) {
            if (typeof window.gtag === 'function') {
                window.gtag('event', 'click', {
                    event_label: buttonLabel,
                });
            } else {
                console.error('gtag is not defined.');
            }
        },
        updateCartTotal(total) {
            this.$refs.appMenulists.getCartTotal();
            this.cartTotal = total
            this.$emit('update-cartTotal', total)
            this.$forceUpdate()
        },
        updateTotalCost() {
            // สร้าง receipt จาก selectedProducts + shop setting
            const receipt = this.buildReceiptFromCart()

            // ใช้สูตรเดียวกับ backend (แต่เป็นเวอร์ชัน JS number)
            const summary = order.calculateReceiptSummary(receipt)

            // เซ็ตค่าไปแสดงบน UI
            this.netAmount = util.convertCurrency(summary.netAmount)
            this.vatAmount = util.convertCurrency(summary.vatAmount)
            this.serviceChargeAmount = util.convertCurrency(summary.serviceCharge)
            this.totalCost = util.convertCurrency(summary.grandTotal)

            // ถ้าต้องการใช้ที่อื่นต่อ
            this.discountAmount = util.convertCurrency(
                this.cartLists?.discountAmount || 0
            )

            this.componentKey += 1
        },
        getCartTotal() {
            let total = this.cartLists.reduce((accum, product) => {
                return accum + product.quantity
            }, 0)

            this.cartTotal = total
        },
        async verifyOrderAble() {
            try {
                const shopObjectId = `${localStorage.getItem('shopObjectId')}`;
                const response = await pos({
                    method: 'get',
                    url: '/api/v3.0/shop/order/able',
                    headers: {
                        shopObjectId: shopObjectId,
                    }
                });
                const isAble = response.data?.data?.success || false;
                this.orderAble = isAble
            } catch (error) {
                console.error('Error calling the orderAble API:', error);
            }
        },
        async getOrderShopSetting() {
            const uid = this.uid || localStorage.getItem('uid')
            const shopObjectId = this.shopObjectId || localStorage.getItem('shopObjectId')
            let params = {
                shopObjectId: shopObjectId,
            }
            try {
                await poscrm({
                    method: 'get',
                    url: '/api/v2.1/' + uid + '/OrderShopSetting',
                    params: params,
                }).then((res) => {
                    this.orderShopSetting = res.data?.data[0] || {}
                })
            } catch (error) {
                console.error('Error fetching order shop setting:', error)
                this.orderShopSetting = {}
            }
        },
        buildReceiptFromCart() {
            const typeOfOrder =
            this.orderType === 'dine-in'
                ? 1
                : this.orderType === 'pickup'
                ? 3
                : 4 // delivery = 4

                let serviceChargePercent =
                        this.orderShopSetting?.serviceCharge ??
                        this.shop?.serviceCharge ??
                        0

                        if (this.orderType !== 'dine-in') {
                        serviceChargePercent = 0   // <- ตรงนี้แหละ เขียนทับ const เลย error
                        }
            // ถ้าตะกร้ามี discount level bill แปะตรงนี้ได้เลย
            const discountAmount = this.cartLists?.discountAmount || 0
            const promotionDiscountAmount = this.cartLists?.promotionDiscountAmount || 0
            const promotionDiscountItem = this.cartLists?.promotionDiscountItem || 0

            const receiptItems = this.selectedProducts.map((p) => {
            return {
                totalAmount: this.toNum(p.totalAmount),                  // base line total
                netAmount: this.toNum(p.netAmount ?? p.totalAmount),     // net line
                totalCost: this.toNum(p.totalCost || 0),
                discountAmount: this.toNum(p.discountAmount || 0),
                quantity: this.toNum(p.quantity || 0),
                vatType: p.productSKU?.vatType || p.vatType || 'V',
                serviceCharge:
                p.serviceCharge === true ||
                p.productSKU?.serviceCharge === true ||
                false,
                deleted_at: p.deleted_at || null,
            }
            })

            return {
                receiptItems,
                vatBase: this.shop?.VAT ?? 7,
                isVATIncluded: this.shop?.isVATIncluded ?? false,
                serviceChargePercent,
                typeOfOrder,
                discountAmount,
                promotionDiscountAmount,
                promotionDiscountItem,
                discountItem: 0, // ถ้ามี discount per item รวมมาจาก backend ให้ใส่แทน 0
                totalCost: 0,
                netAmountIncVAT: 0,
                netTotalIncVAT: 0,
                netAmountNonVAT: 0,
                netTotalNonVAT: 0,
                quantityIncVAT: 0,
                quantityNonVAT: 0,
            }
        },
    },

}
</script>
<style>
.type-button {
    font-size: large;
    background-color: #eeeeee;
    border-radius: 30px;
    color: #3c4b64;
    width: 100%;
}

.type-button-active {
    width: 100%;
    font-size: large;
    border-radius: 30px;
    color: white;
    background-color: var(--bg-color-theme);
}

.type-button-active:hover {
    width: 100%;
    font-size: large;
    border-radius: 30px;
    color: white;
    background-color: var(--bg-color-theme);
}

.btn:focus,
.btn.focus {
    outline: 0;
    -webkit-box-shadow: 0 0 0 0.2rem rgba(102, 160, 220, 0.25);
    box-shadow: 0 0 0 0.2rem rgba(102, 160, 220, 0.25);
}
</style>
